module.exports = __webpack_public_path__ + "img/motor_positon.7466138f.png";